import React from 'react';
import { Box, Container, Typography } from '@mui/material';

const customerQuotes = [
    {
        quote:
            'meDZhub has transformed how we manage post-discharge care. We now have complete visibility into patient recovery at home, and our readmission rates have decreased significantly.',
        name: 'Dr. Rajesh Kumar',
        role: 'Chief Medical Officer',
        org: 'Leading Multi-Specialty Hospital',
    },
    {
        quote:
            'The platform has reduced our administrative burden by 60%. Our staff can now focus on patient care instead of paperwork, and our insurance claims are processed much faster.',
        name: 'Priya Sharma',
        role: 'Operations Director',
        org: 'Rehabilitation Centre Network',
    },
    {
        quote:
            'Having structured workflows and audit-ready documentation gives us confidence in our care delivery. meDZhub is essential for our post-operative care coordination.',
        name: 'Dr. Anita Desai',
        role: 'Head of Clinical Operations',
        org: 'Tertiary Care Hospital',
    },
];

const ProofSection = () => {
    return (
        <Box
            component="section"
            id="proof"
            aria-labelledby="proof-heading"
            sx={{
                py: { xs: 7, md: 8, lg: 8.5 },
                background: 'linear-gradient(180deg, #FFFFFF 0%, #FAFBFF 52%, #F5F8FF 100%)',
                borderTop: '1px solid rgba(0, 102, 255, 0.08)',
                borderBottom: '1px solid rgba(0, 102, 255, 0.08)',
            }}
        >
            <Container maxWidth="lg">
            <Box sx={{ textAlign: 'center', maxWidth: 720, mx: 'auto'}}>
            <Typography
                        component="span"
                        sx={{
                            display: 'inline-block',
                            fontSize: { xs: '0.6875rem', sm: '0.75rem' },
                            fontWeight: 700,
                            letterSpacing: '0.18em',
                            textTransform: 'uppercase',
                            color: '#0066FF',
                            bgcolor: 'rgba(0, 102, 255, 0.1)',
                            px: { xs: 1.75, sm: 2.25 },
                            py: 0.75,
                            borderRadius: 999,
                            mb: 2.5,
                            textAlign:'center',
                        }}
                    >
                        Proof
                    </Typography>
                </Box>
                {/* <Typography
                    id="proof-heading"
                    variant="h2"
                    sx={{
                        fontSize: { xs: '1.75rem', sm: '2rem', md: '2.35rem' },
                        fontWeight: 800,
                        lineHeight: 1.18,
                        letterSpacing: '-0.03em',
                        color: '#0F172A',
                        mb: 3,
                        maxWidth: '22ch',
                    }}
                >
                    Proof
                </Typography> */}

                <Typography
                    component="p"
                    sx={{
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.75,
                        color: 'rgba(15, 23, 42, 0.82)',
                        // maxWidth: '47rem',
                        textAlign: 'center',
                        m: 0,
                    }}
                >
                    Rehab centres fully operational on the platform. 1000+ sessions tracked every
                    month. Growing 40% month on month. Every one of them came in with the same
                    problem: unverified sessions, disputed payouts, documentation they couldn't
                    defend.
                </Typography>

                <Typography
                    component="p"
                    sx={{
                        mt: 2.5,
                        fontSize: { xs: '1rem', sm: '1.0625rem', md: '1.125rem' },
                        lineHeight: 1.72,
                        color: 'rgba(15, 23, 42, 0.82)',
                        // maxWidth: '47rem',
                        textAlign: 'center',
                    }}
                >
                    Built by a team with 15+ years of SaaS experience, focused entirely on home
                    rehabilitation operations in India.
                </Typography>

                <Box
                    sx={{
                        mt: { xs: 4, md: 3.5 },
                        display: 'grid',
                        gridTemplateColumns: { xs: '1fr', md: 'repeat(3, minmax(0, 1fr))' },
                        gap: 2,
                    }}
                >
                    {customerQuotes.map((item) => (
                        <Box
                            key={item.name}
                            sx={{
                                border: '1px solid rgba(15, 23, 42, 0.08)',
                                borderRadius: '16px',
                                p: 2.5,
                                backgroundColor: '#FFFFFF',
                                boxShadow: '0 8px 24px rgba(15, 23, 42, 0.04)',
                            }}
                        >
                            <Typography sx={{ fontSize: '2rem', color: 'rgba(0, 102, 255, 0.2)', lineHeight: 0.8 }}>
                                "
                            </Typography>
                            <Typography
                                sx={{
                                    mt: 1,
                                    fontSize: { xs: '0.95rem', md: '1rem' },
                                    lineHeight: 1.75,
                                    color: 'rgba(15, 23, 42, 0.8)',
                                    fontStyle: 'italic',
                                    minHeight: { md: 170 },
                                }}
                            >
                                {item.quote}
                            </Typography>
                            <Box sx={{ mt: 2, pt: 2, borderTop: '1px solid rgba(15, 23, 42, 0.08)' }}>
                                <Typography sx={{ fontSize: '1rem', fontWeight: 700, color: '#0F172A' }}>
                                    {item.name}
                                </Typography>
                                <Typography sx={{ fontSize: '0.95rem', fontWeight: 600, color: '#0066FF', mt: 0.2 }}>
                                    {item.role}
                                </Typography>
                                <Typography sx={{ fontSize: '0.9rem', color: '#64748B', mt: 0.2 }}>
                                    {item.org}
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Container>
        </Box>
    );
};

export default ProofSection;
